import React, { FC, RefObject, useCallback, useMemo } from 'react'
import styles from 'styles/components/header.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { push } from 'connected-react-router'
import { State } from 'index'
import { getAuthShopRef, getIsAdmin, getStoreRef } from 'reducks/auth/selectors'
import { useIsAdminNotViewingStore } from 'hooks/auth'
import { useIntersectionObserver } from 'hooks/utility'
import { FlexColumn } from 'components/Flex'
import { Spacer } from 'components/Utility'

type Props = {
  headingRef?: RefObject<HTMLHeadingElement>
}

const HeaderLogo: FC<Props> = ({ headingRef }) => {
  const dispatch = useDispatch()
  const isAdmin = useSelector((state: State) => getIsAdmin(state))
  const shopRef = useSelector((state: State) => getAuthShopRef(state))
  const storeRef = useSelector((state: State) => getStoreRef(state))

  const isAdminNotViewingStore = useIsAdminNotViewingStore(isAdmin, storeRef, shopRef)
  const headline = useMemo(() => headingRef?.current?.textContent ?? '', [headingRef?.current?.textContent])
  const { isIntersecting } = useIntersectionObserver(headingRef, true, { threshold: 1 })

  const clickLogoAction = useCallback(() => {
    // PWA環境の場合
    if (window.matchMedia('(display-mode: standalone)').matches) {
      window.location.reload()
    } else {
      if (isAdminNotViewingStore) {
        dispatch(push('/admin/shops'))
      } else {
        dispatch(push('/'))
      }
    }
  }, [isAdminNotViewingStore])

  return isIntersecting ? (
    <h1 className={styles.header__logo} onClick={clickLogoAction} role={'button'}>
      <img src={'/logo/red.svg'} alt={'sacri for Owners'} />
    </h1>
  ) : (
    <FlexColumn alignItems="center">
      <h1 className={styles.header__logo_small} onClick={clickLogoAction} role={'button'}>
        <img src={'/logo/red.svg'} alt={'sacri for Owners'} />
      </h1>
      <Spacer size={4} />
      <span className={styles.header__headline_sticky}>{headline}</span>
    </FlexColumn>
  )
}

export default HeaderLogo
